import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiButtonGroup = {
  defaultProps: { disableRipple: true },
} satisfies Components<Theme>['MuiButtonGroup'];
